import type { Maintenance } from '@models/maintenance';
import service from '@util/service';

export default service(
  'maintenanceHelpers',
  class MaintenanceHelpers {
    isActive(maintenance: Maintenance | undefined | null, date = new Date()): boolean {
      return (
        (maintenance?.enabled &&
          (!maintenance.start || new Date(maintenance.start) <= date) &&
          (!maintenance.end || new Date(maintenance.end) >= date)) ??
        false
      );
    }
  },
);
